function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChalkboardteacher(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.69 4.19a1.5 1.5 0 011.06-.44h16.5a1.5 1.5 0 011.5 1.5v13.5a1.5 1.5 0 01-1.5 1.5h-5.755a.75.75 0 01-.678-.428 4.502 4.502 0 00-8.134 0 .75.75 0 01-.678.428H3.75a1.502 1.502 0 01-1.5-1.5V5.25c0-.398.158-.78.44-1.06zm4.56 12.105a6.004 6.004 0 00-2.697 2.455H3.75V5.25h16.5v13.5h-5.303a6.002 6.002 0 00-2.697-2.455 3.75 3.75 0 10-5 0zm-2-8.795A.75.75 0 016 6.75h12a.75.75 0 01.75.75v9a.75.75 0 01-.75.75h-1.5a.75.75 0 010-1.5h.75v-7.5H6.75V9a.75.75 0 01-1.5 0V7.5zm4.5 3.75a2.25 2.25 0 100 4.5 2.25 2.25 0 000-4.5z",
    fill: props.fill
  }));
}

export default SvgChalkboardteacher;